/** Client-side phone config when org or channel calling is off (matches API disable reasons). */
export const disabledBrowserPhoneConfig = (browserPhoneDisableReason) => ({
  enableBrowserPhone: false,
  browserPhoneDisableReason,
});
